var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('md-button',{staticClass:"back-snaplore-btn",on:{"click":_setup.handleBackSnaplore}},[_c('md-icon',[_vm._v("west")]),_vm._v(" "+_vm._s(_setup.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }